/**
 * Checkbox Component
*/

import React, { FC } from 'react';
import { StyledCheckbox, Span, Wrapper } from './checkbox.style';
import Icon from '../Icon/icon';
import COLORS from '../../style/universal.color';

const Check: FC = (props) => {

  const { children, ...otherProps } = props;

  return (
    <Wrapper {...otherProps}>
      <StyledCheckbox>
        <Icon name='checkmark' fill={COLORS.mlbWhite} />
      </StyledCheckbox>
      <Span>{children}</Span>
    </Wrapper>
  );
};

export default Check;
